module.exports = __webpack_public_path__ + "img/bot_intent_liucheng_ac.ba88b1c2.svg";